<template>
  <!-- Design: PanelDetailHeader — close on the left, previous / next on the right -->
  <header class="panel-detail-header">
    <div class="panel-header-side panel-header-side-start">
      <button class="btn panel-header-btn panel-header-close" type="button" :aria-label="closeLabel" @click="$emit('close')">
        <svg class="panel-header-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" /></svg>
      </button>
    </div>
    <div class="panel-detail-title">
      <slot />
    </div>
    <div class="panel-header-side panel-header-side-end">
      <button class="btn panel-header-btn panel-header-nav" type="button" :aria-label="previousLabel" :disabled="previousDisabled" @click="$emit('previous')">
        <svg class="panel-header-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" /></svg>
      </button>
      <button class="btn panel-header-btn panel-header-nav" type="button" :aria-label="nextLabel" :disabled="nextDisabled" @click="$emit('next')">
        <svg class="panel-header-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" /></svg>
      </button>
    </div>
  </header>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';

@Component
export default class TsPanelHeader extends Vue {
  @Prop({ default: '' }) readonly previousLabel!: string;

  @Prop({ default: '' }) readonly nextLabel!: string;

  @Prop({ type: Boolean, default: false }) readonly previousDisabled!: boolean;

  @Prop({ type: Boolean, default: false }) readonly nextDisabled!: boolean;

  get closeLabel() {
    return AppModule.translation[2511];
  }
}
</script>
